import Socket from '../connection/socket';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { GreenroomState } from '../stores/types/types';
import * as TeleprompterActions from '../stores/actions/teleprompters';
import { LoadTeleprompter } from '../connection/teleprompters';

const teleprompterEdited = async (message: any) => {
	try {
		const {
			SessionReducer: {
				user,
				meeting,
				token,
			},
			TeleprompterReducer: {
				teleprompters,
			},
		} = getState() as GreenroomState;

		let hasTelepromptersToUpdate = false;

		const {
			meeting: messageMeeting,
			users,
			updatedTeleprompters,
		} = message.message;

		if (users && user) {
			hasTelepromptersToUpdate = users.includes(user.gr_user);
		} else if (updatedTeleprompters) {
			hasTelepromptersToUpdate = teleprompters.some(
				(teleprompter) => updatedTeleprompters.includes(teleprompter.id),
			);
		}

		if (token
			&& meeting
			&& meeting.meeting === messageMeeting
			&& user
			&& hasTelepromptersToUpdate
			&& teleprompters
		) {
			const loadTeleprompters = TeleprompterActions.loadTeleprompters(
				token,
				user.gr_user,
				meeting.meeting,
			);

			socketListenerDispatch(loadTeleprompters);
		}
	} catch (exception) {
		console.log(exception);
	}
};

async function teleprompterUpdated(message: any) {
	const {
		SessionReducer: {
			meeting,
			token,
			user,
			session,
		},
	} = getState() as GreenroomState;

	const {
		meeting: messageMeeting,
		users,
		id,
		from,
	} = message.message;

	const teleprompterId = Number(id);
	const shouldUpdateUser = !users || users.includes(user?.gr_user);
	if (
		session !== from
		&& shouldUpdateUser
		&& token
		&& meeting
		&& meeting.meeting === messageMeeting
		&& teleprompterId
	) {
		const teleprompter = await LoadTeleprompter(token, teleprompterId);
		if (teleprompter) {
			socketListenerDispatch(TeleprompterActions.updateSingleTeleprompter(teleprompter));
		}
	}
}

async function mediaTeleprompterDeleted(message: any) {
	const {
		TeleprompterReducer: {
			teleprompters,
			selectedTeleprompters,
		},
	} = getState() as GreenroomState;

	const mediaId = Number(message.message.media_id);
	const teleprompter = teleprompters.find((t) => t.media_id === mediaId);
	if (teleprompter) {
		if (selectedTeleprompters.media === teleprompter.id) {
			socketListenerDispatch(TeleprompterActions.setSelectedTeleprompters(['media', null]));
		}
		socketListenerDispatch(TeleprompterActions.removeTeleprompter(teleprompter.id));
	}
}

export default function Teleprompters(socket: Socket) {
	socket.addListener('teleprompter-edited', teleprompterEdited);
	socket.addListener('teleprompter-updated', teleprompterUpdated);
	socket.addListener('media-teleprompter-deleted', mediaTeleprompterDeleted);
}
